<div
  class="contact-form-wrap"
  [ngClass]="{
    tablet: globalUtilsService.isTablet(),
    mobile: globalUtilsService.isMobile()
  }"
>
  <app-input-select
    class="input"
    [control]="contactFormService.form.get(FormControlName.MediaConsumo)"
    [controlName]="FormControlName.MediaConsumo"
    [options]="[
      { label: 'Menos de R$ 300,00', value: 'Menos de R$ 300,00' },
      { label: 'De R$ 300,00 a R$ 500,00', value: 'De R$ 300,00 a R$ 500,00' },
      { label: 'De R$ 500,00 a R$ 1.000,00', value: 'De R$ 500,00 a R$ 1.000,00' },
      { label: 'De R$ 1.000,00 a R$ 5.000,00', value: 'De R$ 1.000,00 a R$ 5.000,00' },
      { label: 'Mais de R$ 5.000,00', value: 'Mais de R$ 5.000,00' }
    ]"
    label="Média mensal de consumo?*"
    placeholder="Média mensal de consumo?*"
  ></app-input-select>

  <div class="two-inputs">
    <app-input-select
      class="input estado"
      [control]="contactFormService.form.get(FormControlName.Estado)"
      [controlName]="FormControlName.Estado"
      [options]="estados"
      [controlName]="FormControlName.Estado"
      label="Estado*"
      placeholder="Estado*"
    ></app-input-select>
    <app-input-text
      class="input cidade"
      [control]="contactFormService.form.get(FormControlName.Cidade)"
      [controlName]="FormControlName.Cidade"
      [controlName]="FormControlName.Cidade"
      label="Cidade*"
      placeholder="Cidade*"
    ></app-input-text>
  </div>

  <app-input-text
    class="input"
    [control]="contactFormService.form.get(FormControlName.Nome)"
    [controlName]="FormControlName.Nome"
    label="Nome e sobrenome*"
    placeholder="Seu nome*"
  ></app-input-text>

  <app-input-text
    class="input"
    [control]="contactFormService.form.get(FormControlName.Telefone)"
    [controlName]="FormControlName.Telefone"
    label="Telefone"
    maskMode="phone"
    placeholder="Telefone*"
  ></app-input-text>

  <app-input-text
    class="input"
    [control]="contactFormService.form.get(FormControlName.Email)"
    [controlName]="FormControlName.Email"
    label="Seu e-mail"
    placeholder="Seu e-mail*"
  ></app-input-text>

  <div *ngIf="globalUtilsService.isMobile()" class="cut">
    <h2>
      Preencha os dados e
      <span class="blck">entraremos em contato com você!</span>
    </h2>
  </div>

  <app-input-button
    class="button"
    (trigger)="sendMessage()"
    [disabled]="isSendingMessage"
  ></app-input-button>
</div>
